import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { CardSection, CardThumbnail, LoadingIndicator, SimpleCard } from '@ygtechnologies/bygr-frontend-component-library';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';
import Pagination from '@/components/Pagination';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getAllServices } from '@/services/booking';
import { IState } from '@/state/IState';
import { useAsyncState } from '@/utils/hooks';
import theme from './MeetingsExternal.module.scss';

interface MeetingsExternalProps {
    projectId?: number;
}

const MeetingsExternal: React.FC<MeetingsExternalProps> = () => {
    const history = useHistory();
    const projectId = useSelector((state: IState) => state.global.activeProject?.id);
    const [meetings] = useAsyncState(async () => (projectId ? await getAllServices(projectId) : null), [projectId], null);
    const onClick = (meetingId: number) => {
        history.push(`/projects/${projectId}/meetings/${meetingId}`);
    };
    const paginationState = {
        currentPage: 1,
        pageSize: 24,
        totalEntries: 500,
        numberOfPages: 25,
        setPage: () => null,
        initialized: true,
        displayedEntries: {
            start: 0,
            end: 24,
        },
    };
    if (!meetings) return <LoadingIndicator />;
    return (
        <>
            <SimplePageTitle title={t`External meetings`} />

            {meetings
                .filter((x) => x.enabled)
                .map((meeting) => {
                    return (
                        <SimpleCard key={meeting.id} className={theme.card} onClick={() => onClick(meeting.id)}>
                            <CardThumbnail src={meeting.imageUrl} />
                            <CardSection width="10%" grow caption={<Trans>Title</Trans>}>
                                {meeting.name}
                            </CardSection>
                            <CardSection width="40%" grow caption={<Trans>Description</Trans>}>
                                {meeting.description}
                            </CardSection>
                            <CardSection width="10%" grow caption={<Trans>Duration</Trans>}>
                                {meeting.lengthInMinutes} <Trans>minutes</Trans>
                            </CardSection>
                        </SimpleCard>
                    );
                })}
            {meetings.length > 24 && <Pagination value={paginationState} />}
        </>
    );
};

export default MeetingsExternal;
